<template>
  <div id="ramsTrackContactEmailLink" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header" style="font-weight: 600;">
          <template>
            <img src="/static/images/icons/icon_email_black.svg" /> Contact Conformity Declaration Management Support
          </template>
        </div>
        <div class="modal-body" style="padding: 0px;padding-bottom: 10px;padding-top: 20px;">
          <div class="col-md-12" style="padding: 10px;">
            <div class="col-md-2">
              To:
              <span style="color: red;">*</span>
            </div>
            <div class="col-md-10" style="padding: 0;">
              <input type="text" v-model="emergoEmail" class="form-control" disabled />
            </div>
          </div>

          <div class="col-md-12" style="padding: 10px;">
            <div class="col-md-2">Subject:</div>
            <div class="col-md-10" style="padding: 0;">
              <input type="text" class="form-control" v-model="emailSubject" />
            </div>
          </div>

          <div class="col-md-12" style="padding: 10px;">
            <div class="col-md-2">Message:</div>
            <div class="col-md-10" style="padding: 0;">
              <textarea class="form-control" v-model="emailNote"></textarea>
            </div>
          </div>

          <!--{{data}}-->

          <div class="col-md-12" style="padding: 10px;">
            <div class="col-md-2">Contents:</div>
            <div class="col-md-10 share-contact-mail-body">
              <div>
                <p>Here are the required details from Conformity Declaration Management:</p>
              </div>

              <div class="modal-body">
                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">First Name</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <!--{{data['Registration number']}}-->
                        {{loggedInUser.first_name ||  '-'}}
                      </span>
                    </div>
                  </div>
                </div>

                <!--New columns added as per #44342-->
                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Last Name</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <!--{{data['Registration number']}}-->
                        {{loggedInUser.last_name || '-'}}
                      </span>
                    </div>
                  </div>
                </div>

                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">RT Account Name</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <!--{{data['Registration number']}}-->
                        {{loggedInUser.company || '-'}}
                      </span>
                    </div>
                  </div>
                </div>

                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Email Address</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <!--{{data['Registration number']}}-->
                        {{loggedInUser.email ||'-'}}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <hr />
                </div>

                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Record Name</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <!--{{data['Registration number']}}-->
                        {{data['Product'] || '-'}}
                      </span>
                    </div>
                  </div>
                </div>

                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Record Number</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['Record number'] || '-' }}</span>
                    </div>
                  </div>
                  <div class="col-md-12 padding-reset padding-top-edit">
                    <div class="col-md-5">Record Country</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['Country'] || '-'}}</span>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <hr />
                  </div>

                  <div class="col-md-12 padding-reset padding-top-edit">
                    <div class="col-md-5">SF ID</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['salesForceManaged'] || '-'}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="clear: both;">
          <button
            type="button"
            class="btn btn-modal-footer cancel"
            style="float: left;background: #fff;"
            @click="closePopup"
          >
            <i class="fa fa-times-circle"></i> Cancel
          </button>

          <button
            type="button"
            class="btn btn-export"
            style="background: #fff; float: right;"
            @click="sendEmail"
            :disabled="loaderStatus"
          >
            <i class="fa fa-envelope"></i> Send email
          </button>
        </div>
      </div>
      <loader :loadingStatus="loaderStatus"></loader>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
import { sendDetailsByEmail } from '../../apis/email';

export default {
  components: {
    Loader,
  },
  props: {
    data: Object,
    loggedInUser: Object,
  },
  data() {
    return {
      emergoEmail: 'LST.AUS.RepSupport@ul.com',
      emailSubject: 'Conformity Declaration Management Contact us Link',
      errors: [],
      loaderStatus: false,
      emailNote: '',
    };
  },
  methods: {
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },

    async sendEmail() {
      this.loaderStatus = true;
      const shareEmailObj = {};
      shareEmailObj.certOrReg = 3;
      shareEmailObj.certOrRegId = this.data.registrationId;
      shareEmailObj.isSendLinkOnly = false;
      if (this.emailNote) shareEmailObj.mailNotes = this.emailNote;
      shareEmailObj.mailSubject = this.emailSubject;
      shareEmailObj.sendToOption = 1;
      shareEmailObj.mailSendToList = [{ emailId: this.emergoEmail }];
      const result = await sendDetailsByEmail(shareEmailObj);
      this.loaderStatus = false;
      if (result) {
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'English' ? 'Email sent successfully!' : 'E-mail enviado com sucesso!',
          group: 'custom-notification',
        });
        this.closePopup();
      } else {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: 'Unable to sent email!',
          group: 'custom-notification',
        });
      }
    },
    closePopup() {
      this.selectedUsers = [];
      this.emailSubject = 'Conformity Declaration Management Contact us Link';
      this.emailNote = '';
      $('#ramsTrackContactEmailLink').modal('hide');
    },
  },
};
</script>
<style>
.share-contact-mail-body {
  height: 45vh;
  overflow:auto;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
}
</style>
